/**
 * Linaria-compatible equivalents of the helpers in svgIconStyles.ts.
 *
 * The styled-components versions (svgIconStyles, svgPathStyles) return
 * RuleSet<object> via the styled-components `css` tagged template, which
 * can only be interpolated into other styled-components templates at runtime.
 *
 * These versions return plain CSS strings, making them safe to interpolate
 * into Linaria's `styled` templates (which are evaluated at build time).
 *
 * Mapping:
 *   svgIconStyles  -> fillSvg
 *   svgPathStyles  -> strokeSvg
 */

/**
 * CSS for fill-based SVG icons. Equivalent to `svgIconStyles` in svgIconStyles.ts.
 */
export function fillSvg(color: string, transition?: boolean) {
  return `
  fill: ${color};

  g:not([fill="none"]) {
    fill: ${color};
  }

  path {
    transition: ${transition ? "fill 250ms ease" : "none"};
  }

  *[stroke-miterlimit],
  circle,
  ellipse {
    transition: ${transition ? "stroke 250ms ease" : "none"};
    stroke: ${color};
  }

  path[stroke]:not([stroke="none"]) {
    stroke: ${color};
  }

  path[fill]:not([fill="none"]) {
    fill: ${color};
  }

  path[fill="#010101"] {
    fill: ${color};
  }
`
}

/**
 * CSS for stroke-based SVG icons. Equivalent to `svgPathStyles` in svgIconStyles.ts.
 */
export function strokeSvg(color: string, strokeWidth?: number, transition?: boolean) {
  return `
  path,
  rect,
  circle {
    stroke: ${color};
    transition: ${transition ? "stroke 250ms ease" : "none"};

    ${strokeWidth && `stroke-width: ${strokeWidth}px;`};
  }
`
}
